module.exports = __webpack_public_path__ + "static/img/cart.e929452.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cart.svg
// module id = R37o
// module chunks = 1 2